module.exports = __webpack_public_path__ + "img/umi-logo.afcf1cfe.png";